import { render, staticRenderFns } from "./RepairFaqs.vue?vue&type=template&id=1e55fc18&scoped=true"
import script from "./RepairFaqs.vue?vue&type=script&lang=js"
export * from "./RepairFaqs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e55fc18",
  null
  
)

export default component.exports